<template>
  <v-btn flat type="submit" @click="logout">
    <v-icon>exit_to_app</v-icon>
  </v-btn>
</template>

<script>
import AuthenticationService from '../services/AuthenticationService'

export default {
  name: 'Logout',
  methods: {
    logout () {
      AuthenticationService.signOut()
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue